var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3173 13.603H13.6025V67.3178H67.3173V13.603Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4599 67.3178C25.6517 67.3178 13.6025 55.2686 13.6025 40.4604C13.6025 25.6522 25.6517 13.603 40.4599 13.603C55.2681 13.603 67.3173 25.6522 67.3173 40.4604C67.3173 55.2686 55.2681 67.3178 40.4599 67.3178ZM40.4599 15.0041C26.4277 15.0041 15.0036 26.4282 15.0036 40.4604C15.0036 54.4927 26.4277 65.9167 40.4599 65.9167C54.4922 65.9167 65.9163 54.4927 65.9163 40.4604C65.9163 26.4282 54.4922 15.0041 40.4599 15.0041Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4586 22.4614H22.4619V58.4581H58.4586V22.4614Z",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4623 15.0063L15.0088 40.4599L40.4623 65.9134L65.9158 40.4599L40.4623 15.0063Z",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/Round.a8121eee166623cb742dbe5d6ec2c642.svg";
export { ForwardRef as ReactComponent };